module.exports = __webpack_public_path__ + "static/media/3.e182d600.png";